import { render } from "./contact-style.vue?vue&type=template&id=70cd69ea"
import script from "./contact-style.vue?vue&type=script&lang=js"
export * from "./contact-style.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__